import { useRecoilState } from "recoil";
import { instituicoes } from "../atom";

const useInstituicoesState = () => {
    return useRecoilState(instituicoes);
};

export default useInstituicoesState;